import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Button from 'components/MuiComponents/Button';
import { withTranslation } from 'react-i18next';
import Loading from 'react-loading-animation';
import MuiTextField from '@material-ui/core/TextField';
import styled from 'styled-components';

import config from '../../../config';

const emailTest = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const DialogContent = styled(MuiDialogContent)`
  && {
    background-color: white;
  }
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const ImageContainer = styled.div`

`;

const Image = styled.img`

`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.h4`
  font-weight: 400;
`;

const TextField = styled(MuiTextField)`
  && {
    margin-bottom: 1rem;
  }
`;

export default class ComingSoonDialog extends Component {
  static propTypes = {
    mobileDetect: PropTypes.objectOf(PropTypes.any),
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    presetEmail: PropTypes.string,
    success: PropTypes.bool,
    sendingRequest: PropTypes.bool,
    onSendClick: PropTypes.func.isRequired,
  };

  static defaultProps = {
    mobileDetect: {},
    presetEmail: '',
    success: false,
    sendingRequest: false,
  };

  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.state = {
      email: props.presetEmail || '',
      isEmailValid: true,
    };
  }

  handleClose() {
    this.props.handleClose();
  }

  handleEmailChange(e) {
    this.setState({
      email: e.target.value,
    });
  }

  renderNotifyMe() {
    const { mobileDetect, onSendClick, sendingRequest } = this.props;

    const { email, isEmailValid } = this.state;

    const cdnPrefix = `${config.cdnUrl}/misc`;
    const imageComingSoonSrc1x = `${cdnPrefix}/coming-soon@1x.png`;
    const imageComingSoonSrc2x = `${cdnPrefix}/coming-soon@2x.png`;

    const src = mobileDetect.isMobile && !mobileDetect.isTablet
      ? imageComingSoonSrc1x
      : imageComingSoonSrc2x;

    return (
      <Root>
        <ImageContainer>
          <picture>
            <source srcSet={src} />
            <Image
              src={src}
              alt="Login Successfull"
            />
          </picture>
        </ImageContainer>
        <FormContainer>
          <Header>Get notified when this feature is ready?</Header>

          <TextField
            id="outlined-email-input"
            label="Email"
            type="email"
            name="email"
            value={email}
            autoComplete="email"
            margin="normal"
            variant="outlined"
            required
            error={!isEmailValid}
            helperText={isEmailValid ? '' : 'Please enter valid email format'}
            onChange={this.handleEmailChange}
          />

          <Button
            color="primary"
            variant="contained"
            size="medium"
            fullWidth
            onClick={e => {
              e.stopPropagation();
              if (emailTest.test(this.state.email)) {
                this.setState({ isEmailValid: true });
                onSendClick(this.state.email);
              } else {
                this.setState({ isEmailValid: false });
              }
            }}
          >
            { sendingRequest ? <Loading width="18px" height="18px" /> : 'Notify Me' }
          </Button>
        </FormContainer>
      </Root>
    );
  }

  renderSuccess() {
    const src = require('../../../assets/icon-successful.svg');

    return (
      <Root key={`comingsoon-dialog-${new Date().getTime()}`}>
        <ImageContainer>
          <picture>
            <source srcSet={src} />
            <Image
              src={src}
              alt="Send Successfull"
            />
          </picture>
        </ImageContainer>
        <FormContainer>
          <Header>We will let you know as soon as we roll out the feature!</Header>
          <Button
            color="primary"
            variant="contained"
            size="medium"
            fullWidth
            onClick={e => {
              e.stopPropagation();
              this.handleClose();
            }}
          >
            Got It
          </Button>
        </FormContainer>
      </Root>
    );
  }

  render() {
    const {
      isOpen,
      success,
    } = this.props;

    return (
      <Dialog
        modal
        open={isOpen}
      >
        <DialogActions>
          <IconButton
            onClick={e => {
              e.stopPropagation();
              this.handleClose();
            }}
          >
            <ClearIcon />
          </IconButton>
        </DialogActions>
        <DialogContent>
          {
            success
              ? this.renderSuccess()
              : this.renderNotifyMe()
          }
        </DialogContent>
      </Dialog>
    );
  }
}
